/* 中文词典：room 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const room = {
  'room.noRoom': [ '尚未加入任何房间。请返回汇合页创建房间，或输入房间号加入。' ],
  'room.backToMeetup': [ '回汇合页' ],
  'room.lobbyTitle': [ '玩家与操作' ],
  'room.codeHint': [ '房间号 · 点击复制邀请链接' ],
  'room.players': [ '玩家' ],
  'room.playersCount': [ '· ', { type: 'param', name: 'n' }, '/', { type: 'param', name: 'max' } ],
  'room.randomFirst': [ '随机先手' ],
  'room.addBot': [ '＋ 机器人' ],
  'room.addTestPlayer': [ '＋ 测试玩家（dev）' ],
  'room.actions': [ '操作' ],
  'room.ready': [ '准备' ],
  'room.unready': [ '取消准备' ],
  'room.hostValue': [ { type: 'param', name: 'name' }, '（网络最快）' ],
  'room.waitingPlayers': [ '等待玩家进入' ],
  'room.waitingReady': [ '等待玩家准备' ],
  'room.startHotseat': [ '开始对局（热座）' ],
  'room.start': [ '开始对局' ],
  'room.cannotStart': [ '无法开始对局' ],
  'room.leave': [ '离开房间' ],
  'room.sync': [ '刷新同步' ],
  'room.syncRequested': [ '已请求同步' ],
  'room.readonly': [ '（只读）' ],
  'room.deckTitle': [ '牌组' ],
  'room.deckTotal': [ '总计数' ],
  'room.exportConfig': [ '导出配置' ],
  'room.importHint': [ '将配置文件拖入页面即可导入' ],
  'room.imported': [ '已导入：', { type: 'param', name: 'name' } ],
  'room.creatorOnly': [ '只有房主可以修改房间设置。' ],
  'room.badge.creator': [ '房主' ],
  'room.badge.first': [ '先手' ],
  'room.kick': [ '踢出' ],
  'room.packsTitle': [ '内容包' ],
  'room.everyoneHas': [ '所有人都有' ],
  'room.autoByPlayerCount': [ '根据人数配置', { type: 'param', name: 'label' } ],
  'room.listSeparator': [ '、' ],
  'room.error.addBotCreatorOnly': [ '仅创建者可添加机器人' ],
  'room.error.seatsFull': [ '座位已满' ],
  'room.error.kickCreatorOnly': [ '仅创建者可移除玩家' ],
  'room.error.kickSelf': [ '不能移除自己' ],
  'room.error.playerGone': [ '该玩家已不在房间中' ],
  'room.error.configCreatorOnly': [ '仅创建者可修改游戏规则' ],
  'room.error.deckCreatorOnly': [ '仅创建者可修改牌堆' ],
  'room.error.countNumber': [ '张数必须为数字' ],
  'room.pack.missing': [ '缺：', { type: 'param', name: 'names' } ],
  'room.pack.notReported': [ '仍有玩家未上报' ],
  'room.pack.versionMismatch': [ '版本不一致（同 id 的 hash 不同）' ],
  'room.pack.nobodyHas': [ '没有任何玩家安装此内容包' ],
  'room.problem.minPlayers': [ '至少要有 ', { type: 'param', name: 'n' }, ' 个玩家' ],
  'room.problem.maxPlayers': [ '最多 ', { type: 'param', name: 'n' }, ' 个玩家' ],
  'room.problem.notReady': [ { type: 'param', name: 'names' }, ' 未准备' ],
  'room.problem.packDisabled': [ '内容包「', { type: 'param', name: 'id' }, '」无法启用：', { type: 'param', name: 'reason' } ],
  'room.problem.inconsistent': [ '不一致' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
room satisfies Record<string, TextSpec>;
export default room;
